export const SESSION_PHASE = {
  IDLE: "idle",
  RUNNING: "running",
  COMPLETED: "completed",
  SAVING_CONVERSATION: "saving_conversation",
  GETTING_FEEDBACK: "getting_feedback"
} as const;

export type SessionPhase = typeof SESSION_PHASE[keyof typeof SESSION_PHASE];